import { SpecialLayout } from '../types';

export interface ThemeConfig {
  name: string;
  primary: string;
  secondary: string;
  accent: string;
  bg: string;
  text: string;
  heroBg: string;
  pattern?: string;
  emoji: string;
  heroBg5: string;
  heroBg10: string;
  heroBg20: string;
  heroBg30: string;
  heroBg50: string;
  bg10: string;
  bg20: string;
  primary10: string;
  primary40: string;
}

export const THEMES: Record<SpecialLayout, ThemeConfig> = {
  default: {
    name: 'Predeterminado',
    primary: 'text-brand-600',
    secondary: 'bg-brand-600',
    accent: 'border-brand-200',
    bg: 'bg-crema',
    text: 'text-texto',
    heroBg: 'bg-brand-50',
    emoji: '🎁',
    heroBg5: 'bg-brand-50-5',
    heroBg10: 'bg-brand-50-10',
    heroBg20: 'bg-brand-50-20',
    heroBg30: 'bg-brand-50-30',
    heroBg50: 'bg-brand-50-50',
    bg10: 'bg-brand-50-10',
    bg20: 'bg-brand-50-20',
    primary10: 'text-brand-600-10',
    primary40: 'text-brand-600-40',
  },
  father: {
    name: 'Día del Padre',
    primary: 'text-blue-700',
    secondary: 'bg-blue-700',
    accent: 'border-blue-200',
    bg: 'bg-blue-50',
    text: 'text-blue-900',
    heroBg: 'bg-blue-100',
    emoji: '👔',
    heroBg5: 'bg-blue-100/5',
    heroBg10: 'bg-blue-100/10',
    heroBg20: 'bg-blue-100/20',
    heroBg30: 'bg-blue-100/30',
    heroBg50: 'bg-blue-100/50',
    bg10: 'bg-blue-50/10',
    bg20: 'bg-blue-50/20',
    primary10: 'text-blue-700/10',
    primary40: 'text-blue-700/40',
  },
  mother: {
    name: 'Día de la Madre',
    primary: 'text-pink-600',
    secondary: 'bg-pink-600',
    accent: 'border-pink-200',
    bg: 'bg-pink-50',
    text: 'text-pink-900',
    heroBg: 'bg-pink-100',
    emoji: '🌸',
    heroBg5: 'bg-pink-100/5',
    heroBg10: 'bg-pink-100/10',
    heroBg20: 'bg-pink-100/20',
    heroBg30: 'bg-pink-100/30',
    heroBg50: 'bg-pink-100/50',
    bg10: 'bg-pink-50/10',
    bg20: 'bg-pink-50/20',
    primary10: 'text-pink-600/10',
    primary40: 'text-pink-600/40',
  },
  christmas: {
    name: 'Navidad',
    primary: 'text-red-700',
    secondary: 'bg-red-700',
    accent: 'border-green-200',
    bg: 'bg-stone-50',
    text: 'text-red-900',
    heroBg: 'bg-red-50',
    emoji: '🎄',
    heroBg5: 'bg-red-50/5',
    heroBg10: 'bg-red-50/10',
    heroBg20: 'bg-red-50/20',
    heroBg30: 'bg-red-50/30',
    heroBg50: 'bg-red-50/50',
    bg10: 'bg-stone-50/10',
    bg20: 'bg-stone-50/20',
    primary10: 'text-red-700/10',
    primary40: 'text-red-700/40',
  },
  women: {
    name: 'Día de la Mujer',
    primary: 'text-purple-600',
    secondary: 'bg-purple-600',
    accent: 'border-purple-200',
    bg: 'bg-purple-50',
    text: 'text-purple-900',
    heroBg: 'bg-purple-100',
    emoji: '💜',
    heroBg5: 'bg-purple-100/5',
    heroBg10: 'bg-purple-100/10',
    heroBg20: 'bg-purple-100/20',
    heroBg30: 'bg-purple-100/30',
    heroBg50: 'bg-purple-100/50',
    bg10: 'bg-purple-50/10',
    bg20: 'bg-purple-50/20',
    primary10: 'text-purple-600/10',
    primary40: 'text-purple-600/40',
  },
  easter: {
    name: 'Pascuas',
    primary: 'text-yellow-600',
    secondary: 'bg-yellow-600',
    accent: 'border-yellow-200',
    bg: 'bg-yellow-50',
    text: 'text-yellow-900',
    heroBg: 'bg-yellow-100',
    emoji: '🐰',
    heroBg5: 'bg-yellow-100/5',
    heroBg10: 'bg-yellow-100/10',
    heroBg20: 'bg-yellow-100/20',
    heroBg30: 'bg-yellow-100/30',
    heroBg50: 'bg-yellow-100/50',
    bg10: 'bg-yellow-50/10',
    bg20: 'bg-yellow-50/20',
    primary10: 'text-yellow-600/10',
    primary40: 'text-yellow-600/40',
  },
  children: {
    name: 'Día del Niño',
    primary: 'text-orange-500',
    secondary: 'bg-orange-500',
    accent: 'border-orange-200',
    bg: 'bg-orange-50',
    text: 'text-orange-900',
    heroBg: 'bg-orange-100',
    emoji: '🎈',
    heroBg5: 'bg-orange-100/5',
    heroBg10: 'bg-orange-100/10',
    heroBg20: 'bg-orange-100/20',
    heroBg30: 'bg-orange-100/30',
    heroBg50: 'bg-orange-100/50',
    bg10: 'bg-orange-50/10',
    bg20: 'bg-orange-50/20',
    primary10: 'text-orange-500/10',
    primary40: 'text-orange-500/40',
  },
  friend: {
    name: 'Día del Amigo',
    primary: 'text-teal-600',
    secondary: 'bg-teal-600',
    accent: 'border-teal-200',
    bg: 'bg-teal-50',
    text: 'text-teal-900',
    heroBg: 'bg-teal-100',
    emoji: '🤝',
    heroBg5: 'bg-teal-100/5',
    heroBg10: 'bg-teal-100/10',
    heroBg20: 'bg-teal-100/20',
    heroBg30: 'bg-teal-100/30',
    heroBg50: 'bg-teal-100/50',
    bg10: 'bg-teal-50/10',
    bg20: 'bg-teal-50/20',
    primary10: 'text-teal-600/10',
    primary40: 'text-teal-600/40',
  }
};

export const getTheme = (layout?: SpecialLayout): ThemeConfig => {
  return THEMES[layout || 'default'] || THEMES.default;
};
